import {useDispatch, useSelector} from "react-redux";
import {
    setForgetPasswordConstraintDataOnchange,
    setForgetPasswordOnchange
} from "../store/forgetPasswordAction";
import {GraphQLFetchData} from "./graphQLFetchData";
import {useAppSelector} from "../../redux/hooks";



export  const Hooks=()=> {
    const dispatch = useDispatch()
    // use Selector redux
    const values = useAppSelector((state) => state.ForgetPasswordReducer)
   
    
    const {ForgetPassword}=GraphQLFetchData(values)
//******************connexion************************//
    const forgetPasswordOnChange = (event:any) => {
       
        
        dispatch(setForgetPasswordOnchange({
            forgetPasswordNameChange: event.target.name,
            forgetPasswordValueChange: event.target.value
        }));
    };

    const handleSubmit =()=>{
        dispatch(setForgetPasswordConstraintDataOnchange({constraintDataNameChange:"loadingForgetPassword",constraintDataValueChange:true}))
        ForgetPassword()
    }

    return({
        forgetPasswordOnChange,
        handleSubmit,
        values
    })
}